import React, { Component } from 'react'
import {Button,ButtonToolbar,FormControl,Modal} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import SWTPartItemListModal from './SWTPartItemListModal'
import TextFieldModal from '../../component/element/TextFieldModal'
import IframeModal from '../../component/element/IframeModal'
import { Checkbox } from 'react-icheck'
import SWTProgramModal from './SWTProgramModal'
import Select from 'react-select'

export default class SWTPartDataGrid extends Component {
  constructor(props) {
    super(...props)
    
    this.state = {data:this.newEmptyRow(10,1),options:[],codeOptions:[],showPopup:false,showDListQuote:false,showPartCheck:false,dataPart:[],isPartCheck:[],isPartCheckAll:false,showProgram:false}

  }

  getPartList(){
    let {data} = this.state
    return data.reduce((rresult,item)=>{
      if(item.detail!==''){
        rresult.push(item)
      }
      return rresult
    },[])
  }

  setPartList(partList){
    let data = partList.map((item,index)=>{
      return {bfId:item.bf_work_damage_id,itemSeq:item.item_seq,rowNo:item.seq,itemnum:item.itemnum,productCode:item.productcode,detail:item.detail,quantity:item.quantity,exportQuantity:item.export_quantity,pricePerUnit:item.price_per_unit,amount:item.amount,exportStock:item.export_stock_flag}
    })
    if(data.length<=10){
      let itemSeq = data.length>0?data[data.length-1].itemSeq:1
      data = data.concat(this.newEmptyRow(10-data.length,itemSeq))
    }
    this.setState({data:data})
  }

  addItems(partList){
    let {data} = this.state
    // data = data.reduce(function(rresult,item) {
    //   if(item.detail!=='')
    //     rresult.push(item)
    //   return rresult
    // },[])
    data = []
    let seq = data.length
    let newData = partList.map((item,index)=>{
      seq++
      let amount = item.price_per_unit*item.quantity
      return {bfId:'',rowNo:seq,itemnum:item.itemnum,productCode:item.productcode,detail:item.detail,quantity:item.quantity,pricePerUnit:item.price_per_unit,amount:amount,exportStock:false}
    })
    data = data.concat(newData)
    if(data.length<=10){
      let itemSeq = data.length>0?data[data.length-1].itemSeq:1
      data = data.concat(this.newEmptyRow(10-data.length,itemSeq))
    }
    
    this.setState({data:data})
  }

  newEmptyRow(number,itemSeq){
    return new Array(number).fill(null).map((item,index)=>{
      itemSeq = (itemSeq*1 + 0.001).toFixed(3)
      return {bfId:'',rowNo:'',itemSeq:itemSeq,itemnum:'',productCode:'',detail:'',quantity:'',pricePerUnit:'',amount:'',exportStock:'0',partSup:'0'}
    })
  }

  onAddEmptyRowItemClick(){

  }

  onSearch(index,query){
    let that = this
    let {data} = this.state
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
    data[index]['detail'] = query

    this.setState({data:data})
    //this.setState({options:options})
  }

  onCodeSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartProductCodeList(-1,query,function(result){
      
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      
      that.setState({codeOptions:options})
    })
  }

  calculateAmount(data,index){
    data[index].amount = data[index].quantity * data[index].pricePerUnit*1
  }

  onTextChange(index,field,e){
    let {data} = this.state
    
    // let amount = e.target.value
    // if(isNaN(amount)){
    //   data[index][field] = ''
    // }else{
    //   data[index][field] = amount*1
    // }
    // this.calculateAmount(data,index)
    data[index][field] = e.target.value
    if(field==='pricePerUnit' || field==='quantity'){
      //this.calculateAmount(data,index)
      data[index].amount = (data[index].quantity*1) * (data[index].pricePerUnit*1)
    }
    
    this.setState({data:data})
  }


  onSearchKeyPress(index,field,target) {
    if(target.charCode==13){
      let {data} = this.state
      // console.log("code enter",data[index])    
      let that = this
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({loading:false})
      let productCode = data[index][field];
      AutopartStore.loadStockPartProductCode(productCode,function(result){
        // console.log(result)
        //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
        if(result.data.length>0){
          let item = result.data[0]        
          data[index].detail = item.description        
          data[index].productCode = item.productcode
          data[index].itemnum = item.itemnum
          data[index].pricePerUnit = item.price_per_unit
          data[index].costPerUnit = item.cost_per_unit
          data[index].quantity = 1
          data[index].amount  = item.price_per_unit
          // data[index].discountPercent  = item.discount_percent
          // data[index].discountAmount  = item.discount_amount
          data[index].exportStock = '0'
          data[index].exportQuantity = item.quantity
          if(index==data.length-1){
            //End index
            data = data.concat(that.newEmptyRow(1))
            that.pcInput[index+1] = ''
          }
          that.setState({loading:false,data:data})
          if(that.props.onChange!==undefined)
            that.props.onChange(data)
              
          //ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
        }else{
          that.setState({loading:false})
        }
      })      
    }
  }


  onTypeaheadChange(index,option){
    
    let {data} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      if(typeof option[0].productCode !=='undefined'){
        data[index].productCode = option[0].productCode
        data[index].itemnum = option[0].itemnum
        data[index].pricePerUnit = option[0].pricePerUnit
        data[index].quantity = 1
        data[index].amount  = option[0].pricePerUnit
        data[index].exportStock = '0'
      }
    }
    // else{
    //   data[index].detail = ''
    // }
    this.setState({data:data})
  }

  onTypeaheadCodeChange(index,option){

    let {data} = this.state
    if(option.length===1){
      data[index].productCode = option[0].productCode
      if(typeof option[0].detail !=='undefined'){
        data[index].detail = option[0].detail
        data[index].itemnum = option[0].itemnum
        data[index].pricePerUnit = option[0].pricePerUnit
        data[index].quantity = 1
        data[index].amount  = option[0].pricePerUnit
        data[index].exportStock = '0'
      }
    }
    // else{
    //   data[index].detail = ''
    // }
    this.setState({data:data})
  }

  onRemoveRowClick(delIndex){
    let {data} = this.state

    let itemSeq = data[delIndex].itemSeq
    data.splice(delIndex,1);

    let stop =false  
    let runNo = 0.001
    data = data.map((item,index)=>{
      if(index+1<data.length && Math.floor(item.itemSeq*1) !== Math.floor(data[index+1].itemSeq*1)){
        stop = true  
      }
      if(index >= delIndex  && !stop){
        if(index==delIndex){
          item.itemSeq =  itemSeq 
        }else{
          item.itemSeq = (itemSeq*1 + runNo).toFixed(3)          
          runNo += 0.001        
        }
        
      }
      return item
    })
    
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  onAddEmptyRowItemClick(number){
    let {data} = this.state
    let itemSeq = data.length>0?data[data.length-1].itemSeq:1
    let newRows = this.newEmptyRow(number,itemSeq)

    
    this.setState({data:data.concat(newRows)})
  
  }

  onSearchClick(){
    this.refs.partItemPopup.openPopup();
    this.setState({showPopup:true})
  }

  onProgramClick(){
      this.refs.programPopup.getWrappedInstance().openPopup()
      this.setState({showProgram:true})
  }

  onItemSelect(newItem){
    //Finding Last row
    let {data} = this.state
    let foundItem = false
    data.map((item,index)=>{
      if(item.detail==='' && foundItem==false){
        item.productCode = newItem.productcode
        item.detail = newItem.description
        item.quantity = 1
        item.pricePerUnit = newItem.price_per_unit        
        item.amount = newItem.price_per_unit
        foundItem = true
      }
    })

    this.setState({data:data})
  }

  onProgramSelect(wageItem,partItem,program){
    let {data} = this.state
    // let popupStore = AlertPopupStore    

    // popupStore.confirm('มีรายการค่าแรงอยู่แล้ว ต้องการ',[{id:1,title:'ใส่ทับของเดิม'},{id:2,title:'ต่อรายการท้ายของเดิม'},{id:3,title:'กลับไปแก้ไข'}],function(id){

    // data = data.reduce(function(rresult,item) {
    //   if(item.detail!=='')
    //     rresult.push(item)
    //   return rresult
    // },[])     
    data = []
    // })
    let rowNo = data.length
    let newItems = wageItem.map((item,index)=>{
      rowNo++
      return {bfId:'',rowNo:rowNo,itemcode:item.wage_itemnum,detail:item.detail,pricePerUnit:item.wage_cost,quantity:item.quantity,amount:item.wage_cost}  
    })
    data = data.concat(newItems)    
    if(data.length<=10){
      let itemSeq = data.length>0?data[0].itemSeq:1
      data = data.concat(this.newEmptyRow(10-data.length,itemSeq))
    }    
    this.setState({data:data,program:program})
    if(typeof this.props.onProgramChange !=='undefined')
      this.props.onProgramChange(wageItem,partItem,program)
  }

  onSeqClick(index){
    let {data} = this.state
    let fieldInfo = {title:'เปลี่ยนลำดับ',showClear:true,index:index,value:'' }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  onDamageSeqSave(fieldInfo){
    let {data} = this.state
    let itemSeq = fieldInfo.value*1

    if(fieldInfo.value===''){
      //Insert Empty Row
      let item = this.newEmptyRow(1,data[fieldInfo.index].itemSeq)[0]
      data.splice(fieldInfo.index+1, 0, item);    
      let stop =false  
      data = data.map((item,index)=>{
        if(index-1 > fieldInfo.index  && !stop){
          item.itemSeq = (item.itemSeq*1 + 0.001).toFixed(3)
          if(index+1<data.length && Math.floor(item.itemSeq*1) !== Math.floor(data[index+1].itemSeq*1)){
            stop = true  
          }
        }
        return item
      })
    }
    else if(fieldInfo.index==0&&fieldInfo.value=='0'){
      data = data.map((item,index)=>{
        item.itemSeq = index+1
        return item
      })
    }else{
      let runNo = 0.001
      data = data.map((item,index)=>{
        if(fieldInfo.index==index){          
          item.itemSeq = itemSeq
        }
        else if(index>fieldInfo.index){
          item.itemSeq = (itemSeq*1 + runNo).toFixed(3)          
          runNo += 0.001          
        }
        return item
      })
    }
    
    this.setState({data:data})
  }

  onPartSupChange(index,e) {
    let {data} = this.state
    data[index].partSup = e.value
    this.setState({data:data})
  }

  valueValid(value) {
    value = (value==''||value==null||value==undefined||isNaN(value)?0:value)
    return value
  }

  summaryAmount(){
    let {data} = this.state
    let sum = 0;
     data.map((item,index)=>{
        sum += this.valueValid(item.amount)*1
    })
    
    return (<span>{sum}</span>)
  }

  _renderMenuItemChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  _renderMenuItemProductCodeChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.productCode} {option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.productCode} {option.detail}</span>
        </div>
      );
    }
  }

  renderCheckStock(exportStock){
    if(exportStock==='1'){
      return (<FontAwesome name='check' className='text-large'/>)
    }else{
      return (<div/>)
    }
  }


  renderSeq(itemSeq){
    let list = (itemSeq+"").split(".");
    let newSeq = itemSeq
    if(list.length==2){
      let digit = (list[1]+"").replace(/^0+/, '')
      newSeq = list[0]+"."+digit
    }
    return (<span>{newSeq}</span>)
  }

  renderTdProductCode(item,index){
    return (
      <td className='text-right'>
        <FormControl className='text-left'                   
                  value={item.productCode} 
                  onChange={this.onTextChange.bind(this,index,'productCode')}
                  onKeyPress={this.onSearchKeyPress.bind(this,index,'productCode')}
                  />                 
      </td>
    )
  }


  renderRowData(){
    let {data,options,codeOptions} = this.state
    return data.map((item,index)=>(            
              <tr key={index}>
                <td className='text-center'>
                  <span >{index+1}</span>
                </td>     
                {this.props.showProductCode?this.renderTdProductCode(item,index):''}                           
                <td>
                  <AsyncTypeahead
                    allowNew={true}
                    multiple={false}
                    newSelectionPrefix={'เพิ่มรายการใหม่ : '}   
                    promptText={'พิมพ์รายการเพื่อค้นหา...'}           
                    searchText={'กำลังค้นหา...'}                    
                    selected={[{detail:item.detail}]}
                    options={options}
                    labelKey="detail"
                    onSearch={this.onSearch.bind(this,index)}
                    onChange={this.onTypeaheadChange.bind(this,index)}
                    placeholder=""
                    renderMenuItemChildren={this._renderMenuItemChildren}
                  />                  
                </td>
                {this.props.showPartSup?this.renderTdPartSup(item,index):''}
                <td className='text-right'>
                  <FormControl className='text-center' 
                  value={item.quantity} 
                  onChange={this.onTextChange.bind(this,index,'quantity')}/>                  
                </td>
                <td className='text-right'>
                  <FormControl className='text-right' 
                  value={item.pricePerUnit} 
                  onChange={this.onTextChange.bind(this,index,'pricePerUnit')}/>                  
                </td>
                <td className='text-right'>
                  <FormControl className='text-right'                   
                  value={item.amount} />                  
                </td>  
                <td className='text-center'>
                  <span>{item.exportQuantity} </span>               
                </td>                
                <td>
                  <Button bsStyle={'danger'} bsSize={'sm'} onClick={this.onRemoveRowClick.bind(this,index)}><FontAwesome name="trash"/></Button>
                </td>
              </tr>
            )
          )
  }

  renderTdPartSup(item,index) {
    let options = [{label:'โปรดระบุ',value:'0'},{label:'อู่',value:'garage'},{label:'สาขา',value:'branch'},{label:'ประกัน',value:'insure'},{label:'ลูกค้า',value:'customer'}]
    return(
      <td>
        <Select
          placeholder={'โปรดระบุ'}
          clearable={false}
          options={options}
          value={item.partSup}
          onChange={this.onPartSupChange.bind(this,index)}
        />
      </td>
    )
  }

  renderThPartSup() {
    return(
      <th style={{width:'120px'}} className='text-center'>ผู้จัดอะไหล่</th> 
    )
  }


  renderProductCode() {
    return(
      <th style={{width:'120px'}} className='text-center'>รหัสสินค้า</th> 
    )
  }

  renderTable(){
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th style={{width:'50px'}}  className='text-center'>ลำดับ</th>       
              {this.props.showProductCode?this.renderProductCode():''}     
              <th className='text-center'>รายการ</th>
              {this.props.showPartSup?this.renderThPartSup():''}
              <th style={{width:'70px'}} className='text-center'>จำนวน</th>     
              <th style={{width:'150px'}} className='text-center'>ราคาต่อหน่วย</th>
              <th style={{width:'150px'}} className='text-center'>จำนวนเงิน</th>    
              <th style={{width:'70px'}} className='text-center'>สต็อก?</th>                     
              <th style={{width:'50px'}} className='text-center'>ลบ</th>            
            </tr>          
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={this.props.showPartSup?5:4} className='text-right'>รวมราคาค่าอะไหล่ (บาท)</th>            
              <th className='text-right'>{this.summaryAmount()}</th>
              <th colSpan={2}></th>
            </tr>
          </tfoot>
        </table>
      </div>  
    )
  }

  onPrintPartCheckListClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintKKCDamagePartCheckList&number=1&car_type=SEDAN&wo=' + this.props.workNo
    } else{
      url = './pdf/v2/?startPage=PrintKKCDamagePartCheckList&number=1&car_type=SEDAN&wo=' + this.props.workNo
    }
    this.refs.iframe.loadUrl(url)
  }

  onPartClickAll() {
    let {isPartCheckAll,dataPart,isPartCheck,data} = this.state
    if (isPartCheckAll) {
      isPartCheckAll = false
      isPartCheck = []
      dataPart.forEach(function(item,index) {
        if (data.findIndex(x => x.detail===item.description)!==-1)
          isPartCheck.push(index)
      })
    } else {
      isPartCheck = []
      isPartCheckAll = true
      dataPart.forEach(function(item,index) {
        isPartCheck.push(index)
      })
    }
    this.setState({isPartCheckAll:isPartCheckAll,isPartCheck:isPartCheck})
  }

  onPartCheckListClick() {
    let {isPartCheck,isPartCheckAll,data} = this.state
    isPartCheck = []
    isPartCheckAll = false
    this.setState({showPartCheck:true,loading:true})
    WorkdocStore.loadPartListPhotoBook(this.props.workNo,(result)=>{
      result.data.forEach(function(item,index) {
        if (data.findIndex(x => x.detail===item.description)!==-1)
          isPartCheck.push(index)
      })

      if (isPartCheck.length===result.data.length)
        isPartCheckAll = true

      this.setState({dataPart:result.data,loading:false,isPartCheck:isPartCheck,isPartCheckAll:isPartCheckAll})
    })
  }

  onPartClick(index) {
    let {isPartCheck,isPartCheckAll,dataPart,data} = this.state
    if (isPartCheck.indexOf(index)!==-1) {
      if (data.findIndex(x => x.detail===dataPart[index].description)===-1) {
        let key = isPartCheck.indexOf(index)
        isPartCheck.splice(key,1)
        isPartCheckAll = false
      }  
    } else {
      isPartCheck.push(index)
      if (dataPart.length===isPartCheck.length)
        isPartCheckAll = true
    }

    this.setState({isPartCheck:isPartCheck,isPartCheckAll:isPartCheckAll})
  }

  renderPartCheckRowData() {
    let {dataPart,isPartCheck} = this.state
    if (dataPart.length===0) {
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        dataPart.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>
                <Checkbox
                  onChange={this.onPartClick.bind(this,index)}
                  checked={isPartCheck.indexOf(index)!==-1?true:false}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </td>
              <td className='text-center'>{item.productcode}</td>
              <td>{item.description}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTablePartCheck() {
    let {isPartCheckAll} = this.state
    return(
      <div className='table-responsive'>
        <table className='table table-bordered-solid'>
          <thead>
            <tr>
              <th className='text-center'>
                <Checkbox
                  onChange={this.onPartClickAll.bind(this)}
                  checked={isPartCheckAll}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=" ทั้งหมด"
                >
                </Checkbox>
              </th>
              <th className='text-center'>P.C.Y NO.</th>
              <th className='text-center'>รายการ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderPartCheckRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  onPartCheckPullClick() {
    let {data,isPartCheck,dataPart} = this.state
    let _setPart = []
    
    dataPart.forEach(function(item,index) { 
      if (isPartCheck.indexOf(index)!==-1&&data.findIndex(x => x.detail===item.description)===-1)
        _setPart.push({bfId:'',rowNo:'',itemSeq:(1*1 + 0.001).toFixed(3),itemnum:'',productCode:item.productcode,detail:item.description,quantity:1,pricePerUnit:0,amount:0,exportStock:'0'})
    })
    
    let indexEmpty = []
    let indexDelete = []
    data.forEach(function(item,index) {
      if (item.bfId===''&&item.pricePerUnit==='')
        indexEmpty.push(index)
    })
    
    if (indexEmpty.length===0) {
      _setPart.forEach(function(item,index) {
        data.push(item)
      })
      _setPart = []
    } else {
      
      indexEmpty.forEach(function(item,index) {
        if (_setPart[index]!==undefined) {
          data[item].productCode = _setPart[index].productCode
          data[item].detail = _setPart[index].detail
          data[item].quantity = _setPart[index].quantity
          data[item].pricePerUnit = _setPart[index].pricePerUnit
          data[item].amount = _setPart[index].amount
          data[item].exportStock = '0'
          indexDelete.push(index)
        }  
      })

      indexEmpty = []
      if (_setPart.length>0) {
        _setPart.forEach(function(item,index) {
          if (indexDelete[index]===undefined)  
            data.push(item)
        })
        _setPart = []
      }
    }  

    this.setState({showPartCheck:false,data})
  }

  render() {
    let {showPopup,showProgram,showDListQuote,showPartCheck} = this.state
    let {showProgramButton} = this.props
    return (
      <div>
        {this.renderTable()}
        <ButtonToolbar>
          <Button bsStyle={null} className='bg-olive'           
            onClick={this.onAddEmptyRowItemClick.bind(this,1)}
          >
            +เพิ่มรายการ
          </Button>
          <Button bsStyle={null} className='bg-olive' 
            onClick={this.onAddEmptyRowItemClick.bind(this,10)}
          >
            +เพิ่ม 10 รายการ
          </Button>
          <Button bsStyle={'primary'}             
            onClick={this.onSearchClick.bind(this)}
          >
          <FontAwesome name='search'/>&nbsp;ค้นหาอะไหล่
          </Button>
          <Button bsStyle={'warning'}   style={{display:(this.props.showQuotationButton?'':'none')}}           
            
          >
          <FontAwesome name='search'/>&nbsp;ค้นหาอะไหล่จากใบเสนอราคา
          </Button>
          <Button bsStyle={'success'}             
            onClick={this.onPartCheckListClick.bind(this)}    
          >
          <FontAwesome name='download'/>&nbsp;ดึงรายการตรวจเช็ค
          </Button>
          <button className='btn btn-purple' style={{display:(showProgramButton)?'block':'none'}} 
              onClick={this.onProgramClick.bind(this)}
            >
              <FontAwesome name='book'/>&nbsp;เลือกโปรแกรม
          </button>
        </ButtonToolbar>
        <TextFieldModal ref='textFieldModal'
        confirmTitle='เปลี่ยน'
        deleteTitle='แทรกบรรทัด'
        onConfirm={this.onDamageSeqSave.bind(this)}
        onClear={this.onDamageSeqSave.bind(this)}
        />
        <SWTPartItemListModal ref='partItemPopup' show={showPopup} onSelect={this.onItemSelect.bind(this)} onHide={()=>{this.setState({showPopup:false})}}/>
        <SWTProgramModal ref={'programPopup'} show={showProgram} 
          workNo={this.props.workNo}
          onSelect={this.onProgramSelect.bind(this)} onHide={()=>{this.setState({showProgram:false})}}/>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        <Modal show={showPartCheck} onHide={()=>this.setState({showPartCheck:false})}>
          <Modal.Header closeButton>
            <Modal.Title>รายการตรวจเช็ค</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderTablePartCheck()}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle={'success'} onClick={this.onPartCheckPullClick.bind(this)}>
              <FontAwesome name='download'/>&nbsp;ดึงรายการตรวจเช็ค
            </Button>
            <Button onClick={()=>this.setState({showPartCheck:false})}><FontAwesome name='close' />&nbsp;ปิด</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

SWTPartDataGrid.defaultProps = {
  showProductCode : false,
  showQuotationButton :true
}




// WEBPACK FOOTER //
// ./src/view/workdoc/SWTPartDataGrid.js